import axios from "axios";

export default function setUpAxios(): void {
  require("es6-promise").polyfill();
  const token = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute("content");
  axios.defaults.headers.common["X-CSRF-Token"] = token;
  axios.defaults.headers.common["Accept"] = "application/json";
  axios.defaults.headers.common["x-bonusly-source"] = "internal";
  axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
}

export function browserIsInternetExplorer(): boolean {
  return window.navigator.userAgent.match(/msie|trident/i) != null;
}
